import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import Layout from './components/Layout';
import Home from './pages/Home';
import ProviderProfile from './pages/ProviderProfile';
import ProviderSignup from './pages/ProviderSignup';
import ProviderApplication from './pages/ProviderApplication';
import UserProfile from './pages/UserProfile';
import Messages from './pages/Messages';
import Bookings from './pages/Bookings';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Profile from './pages/Profile';
import PrivateRoute from './components/PrivateRoute';
import { NotificationProvider } from './contexts/NotificationContext';
import { AuthProvider } from './contexts/AuthContext';
import theme from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <NotificationProvider>
          <Router>
            <Layout>
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/providers/:id" element={<ProviderProfile />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                
                {/* Protected Routes - Regular Users */}
                <Route element={<PrivateRoute />}>
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/messages" element={<Messages />} />
                  <Route path="/bookings" element={<Bookings />} />
                  <Route path="/provider-application" element={<ProviderApplication />} />
                </Route>
                
                {/* Protected Routes - Providers Only */}
                <Route element={<PrivateRoute requireProvider={true} />}>
                  <Route path="/provider-dashboard" element={<UserProfile />} />
                </Route>
                
                {/* Legacy Routes (to be updated later) */}
                <Route path="/provider-signup" element={<ProviderSignup />} />
                <Route path="/profile/:id" element={<UserProfile />} />
              </Routes>
            </Layout>
          </Router>
        </NotificationProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App; 